<h1 mat-dialog-title>Item</h1>
<div mat-dialog-content>
    <form [formGroup]="itemFormGroup">
      <mat-form-field appearance="fill">
        <mat-label>ID</mat-label>
        <input type="text" matInput [formControl]="itemFormGroup.controls['id']">
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Name</mat-label>
        <input type="text" matInput [formControl]="itemFormGroup.controls['name']">
        <mat-error *ngIf="itemFormGroup.controls['name'].hasError('required')">
          Item name is <strong>required</strong>
        </mat-error>
      </mat-form-field>
    </form>
</div>
<div mat-dialog-actions class="actions">
  <button mat-stroked-button (click)="close()">Close</button>
  <button type="submit" mat-raised-button color="primary" cdkFocusInitial (click)="submit()" [disabled]="!itemFormGroup.valid">Save</button>
</div>
